// src/services/OrderServices.js
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "",
});

API.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// ✅ Create new checkout order
export async function createCheckoutOrder(
  customer,
  merchantOrderId,
  amountPaisa,
  metadata = {}
) {
  const resp = await API.post("/phonepe/checkout", {
    merchantOrderId,
    amountPaisa,
    metadata: {
      ...metadata,
      customer,
    },
  });
  return resp.data.order; // { txnRef, totalAmount, redirectUrl, phonepeOrderId, merchantOrderId }
}

// ✅ Get order status (needs both IDs)
export async function getOrderStatus(phonepeOrderId, merchantOrderId) {
  const resp = await API.get(
    `/phonepe/order/${encodeURIComponent(phonepeOrderId)}/status`,
    {
      params: { merchantOrderId },
    }
  );
  return resp.data; // { success, data: { state: COMPLETED/FAILED, ... } }
}

// ✅ Fetch all orders for logged-in user
export async function fetchMyOrders() {
  const resp = await API.get('/orders/my-orders');
  // backend returns { orders: [...] }
  return resp.data.orders || resp.data;
}
